import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}

.dashboard-wrap {
  min-height: 100%;
  background: #f5f6f8;
}

.banner {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 50%, #2563eb 100%);
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}
.banner::after {
  content: "";
  position: absolute;
  top: -30%;
  right: -5%;
  width: 200px;
  height: 200px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.banner-content {
  padding: 24px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  transition: all 0.15s ease;
}

.banner-btn-primary {
  background: white;
  color: #1e40af;
}
.banner-btn-primary:hover {
  background: #eff6ff;
}

.banner-btn-outline {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.banner-btn-outline:hover {
  background: rgba(255, 255, 255, 0.25);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  font-weight: 700;
  color: #18181b;
}

.stats-bar {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 0;
  overflow: hidden;
}

.stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 12px;
  transition: background 0.15s ease;
}
.stat-item:hover {
  background: #f9fafb;
}

.stat-number {
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1;
}

.stat-name {
  font-size: 12px;
  color: #6b7280;
  margin-top: 6px;
  font-weight: 500;
}

.stat-unit {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: #e5e7eb;
  flex-shrink: 0;
}

.subject-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.subject-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.subject-card:hover {
  border-color: #93c5fd;
  background: #f8faff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}
.subject-card:hover .subject-enter-btn {
  background: #2563eb;
  color: white;
}

.subject-card-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.subject-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.subject-info {
  display: flex;
  flex-direction: column;
}

.subject-name {
  font-size: 14px;
  font-weight: 700;
  color: #18181b;
}

.subject-meta {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

.subject-card-right {
  flex-shrink: 0;
}

.subject-enter-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 14px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  background: #eff6ff;
  border: none;
  transition: all 0.15s ease;
}

.accent-blue {
  background: #eff6ff;
}

.accent-green {
  background: #ecfdf5;
}

.accent-amber {
  background: #fffbeb;
}

.accent-sky {
  background: #f0f9ff;
}

.accent-rose {
  background: #fff1f2;
}

.quick-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: white;
  cursor: pointer;
  transition: all 0.15s ease;
}
.quick-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.quick-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.quick-card-quiz .quick-card-icon {
  background: #eff6ff;
  color: #2563eb;
}
.quick-card-quiz:hover {
  border-color: #93c5fd;
  background: #f8faff;
}

.quick-card-mock .quick-card-icon {
  background: #fef3c7;
  color: #d97706;
}
.quick-card-mock:hover {
  border-color: #fcd34d;
  background: #fffdf5;
}

.quick-card-wrong .quick-card-icon {
  background: #ffe4e6;
  color: #e11d48;
}
.quick-card-wrong:hover {
  border-color: #fda4af;
  background: #fff8f8;
}

.quick-card-body {
  min-width: 0;
}

.quick-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #18181b;
}

.quick-card-desc {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 2px;
}

.exam-table {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.exam-table-header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
}

.exam-table-row {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: background 0.1s ease;
}
.exam-table-row:last-child {
  border-bottom: none;
}
.exam-table-row:hover {
  background: #f9fafb;
}

.exam-col-grade {
  width: 80px;
  flex-shrink: 0;
}

.exam-col-subject {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.exam-col-score {
  width: 70px;
  flex-shrink: 0;
  text-align: center;
  font-weight: 600;
}

.exam-col-correct {
  width: 70px;
  flex-shrink: 0;
  text-align: center;
}

.exam-col-date {
  width: 100px;
  flex-shrink: 0;
  text-align: center;
  color: #9ca3af;
  font-size: 12px;
}

.exam-col-action {
  width: 32px;
  flex-shrink: 0;
  text-align: center;
}

.grade-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
}

.grade-badge-blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.grade-badge-green {
  background: #dcfce7;
  color: #15803d;
}

.grade-badge-yellow {
  background: #fef9c3;
  color: #a16207;
}

.grade-badge-red {
  background: #ffe4e6;
  color: #be123c;
}

.grade-badge-none {
  background: #f3f4f6;
  color: #9ca3af;
}

.exam-type-badge {
  display: inline-flex;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: #f5f3ff;
  color: #7c3aed;
}

.welcome-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 48px 24px;
  text-align: center;
}

.welcome-icon {
  font-size: 48px;
  line-height: 1;
}

.welcome-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.15s ease;
}

.welcome-btn-primary {
  background: #2563eb;
  color: white;
}
.welcome-btn-primary:hover {
  background: #1d4ed8;
}

.welcome-btn-outline {
  background: white;
  color: #374151;
  border: 1px solid #d1d5db;
}
.welcome-btn-outline:hover {
  background: #f9fafb;
}

@media (max-width: 640px) {
  .banner-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
  }
  .banner-btn {
    padding: 8px 14px;
    font-size: 12px;
  }
  .stats-bar {
    flex-wrap: wrap;
  }
  .stat-item {
    min-width: 0;
    flex: 1 1 45%;
    padding: 14px 8px;
  }
  .stat-divider {
    display: none;
  }
  .stat-number {
    font-size: 20px;
  }
  .exam-table-header {
    display: none;
  }
  .exam-table-row {
    flex-wrap: wrap;
    gap: 4px;
  }
  .exam-col-grade {
    width: auto;
  }
  .exam-col-subject {
    flex-basis: 100%;
    order: -1;
    margin-bottom: 4px;
  }
  .exam-col-score,
  .exam-col-correct,
  .exam-col-date {
    width: auto;
    flex: 1;
    text-align: left;
  }
  .exam-col-action {
    display: none;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public subjects: any[] = [];
    public totalQuestions: number = 0;
    public recentExams: any[] = [];
    public wrongCount: number = 0;
    public wrongMastered: number = 0;
    public totalExams: number = 0;
    public avgScore: number = 0;
    public bestGrade: number = 0;
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("overview");
        if (code === 200) {
            this.subjects = data.subjects || [];
            this.totalQuestions = data.total_questions || 0;
            this.recentExams = data.recent_exams || [];
            this.wrongCount = data.wrong_count || 0;
            this.wrongMastered = data.wrong_mastered || 0;
            this.totalExams = data.total_exams || 0;
            this.avgScore = data.avg_score || 0;
            this.bestGrade = data.best_grade || 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public gradeLabel(grade: number): string {
        if (!grade || grade === 0) return '-';
        return grade + '등급';
    }

    public gradeColor(grade: number): string {
        if (grade <= 2) return 'text-blue-600';
        if (grade <= 4) return 'text-green-600';
        if (grade <= 6) return 'text-yellow-600';
        return 'text-red-500';
    }

    public gradeBg(grade: number): string {
        if (grade <= 2) return 'bg-blue-50';
        if (grade <= 4) return 'bg-green-50';
        if (grade <= 6) return 'bg-yellow-50';
        return 'bg-red-50';
    }

    public gradeBadgeClass(grade: number): string {
        if (grade <= 2) return 'grade-badge-blue';
        if (grade <= 4) return 'grade-badge-green';
        if (grade <= 6) return 'grade-badge-yellow';
        return 'grade-badge-red';
    }

    public examGradeText(exam: any): string {
        if (!exam.result) return '-';
        if (exam.subject_id === 'qualify_past') {
            return exam.result.grade >= 1 ? '합격' : '불합격';
        }
        return exam.result.grade > 0 ? exam.result.grade + '등급' : '-';
    }

    public examGradeBadgeClass(exam: any): string {
        if (!exam.result) return 'grade-badge-none';
        if (exam.subject_id === 'qualify_past') {
            return exam.result.grade >= 1 ? 'grade-badge-green' : 'grade-badge-red';
        }
        return exam.result.grade > 0 ? this.gradeBadgeClass(exam.result.grade) : 'grade-badge-none';
    }

    public formatTime(seconds: number): string {
        if (!seconds) return '-';
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}분 ${s}초`;
    }

    public formatDate(d: string): string {
        if (!d) return '-';
        return d.substring(0, 10);
    }

    public getSubjectIcon(name: string): string {
        if (name?.includes('기출')) return '📝';
        if (name?.includes('한국사')) return '🏛️';
        if (name?.includes('세계사')) return '🌍';
        if (name?.includes('동아시아')) return '🏯';
        if (name?.includes('중등')) return '📖';
        if (name?.includes('한능검')) return '🏆';
        return '📚';
    }

    public getSubjectAccent(idx: number): string {
        const accents = ['accent-blue', 'accent-green', 'accent-amber', 'accent-sky', 'accent-rose', 'accent-teal'];
        return accents[idx % accents.length];
    }

    public viewResult(examId: string) {
        this.service.href(`/quiz/result/${examId}`);
    }
}

export default PageDashboardComponent;